// extracted by mini-css-extract-plugin
export var banner = "training-page-module--banner--9951a";
export var bannerContent = "training-page-module--bannerContent--d62f5";
export var clues = "training-page-module--clues--d5341";
export var description = "training-page-module--description--cb4f5";
export var loader = "training-page-module--loader--70250";
export var relatedExercises = "training-page-module--relatedExercises--46c76";
export var relatedSeparator = "training-page-module--relatedSeparator--d7cdf";
export var seeAllButton = "training-page-module--seeAllButton--cfd87";
export var separator = "training-page-module--separator--9b219";
export var trainer = "training-page-module--trainer--6040c";
export var video = "training-page-module--video--068e7";
export var wrapper = "training-page-module--wrapper--a1215";